module.exports = __webpack_public_path__ + "img/zhjt.a6548baa.png";